import { makeAutoObservable, runInAction } from 'mobx'
import apiClient from '../utils/apiClient'
import { registerTenantScopedReset } from '../tenancy/tenantScopedState'
import { canManageDictionaries } from '../tenancy/resourcePermissions'

export class RequestSourceStore {
  sources = []
  loading = false
  error = null
  permissions = null

  constructor() {
    makeAutoObservable(this)
  }

  clearOrganizationState() {
    this.sources = []
    this.loading = false
    this.error = null
    this.permissions = null
  }

  async fetchSources() {
    this.loading = true
    this.error = null
    try {
      const response = await apiClient.get('/request-sources')
      const { items, permissions } = response.data || {}
      runInAction(() => {
        this.sources = Array.isArray(items) ? items : []
        this.permissions = permissions || null
      })
      return this.sources
    } catch (error) {
      runInAction(() => { this.error = error.response?.data || error })
      throw error
    } finally {
      runInAction(() => { this.loading = false })
    }
  }

  get canManageDictionaries() {
    return canManageDictionaries({ permissions: this.permissions })
  }

  async createSource(name) {
    const response = await apiClient.post('/request-sources', { name })
    runInAction(() => { this.sources.push(response.data) })
    return response.data
  }

  async updateSource(id, changes) {
    const response = await apiClient.patch(`/request-sources/${id}`, changes)
    runInAction(() => {
      const index = this.sources.findIndex(source => source.id === id)
      if (index >= 0) this.sources[index] = response.data
    })
    return response.data
  }

  async deleteSource(id) {
    try {
      await apiClient.delete(`/request-sources/${id}`)
      runInAction(() => { this.sources = this.sources.filter(source => source.id !== id) })
    } catch (error) {
      runInAction(() => { this.error = error.response?.data || error })
      throw error
    }
  }
}

const requestSourceStore = new RequestSourceStore()
registerTenantScopedReset('request-sources', () => requestSourceStore.clearOrganizationState())
export default requestSourceStore
